import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { EnvironmentInfo } from "./components/EnvironmentInfo";
import { PrivateRoute } from "./components/PrivateRoute";
import { AuthDebugger } from "./components/debug/AuthDebugger";
import Layout from "./components/layout/Layout";
import Login from "./features/auth/components/Login";
import RecuperarSenha from "./features/auth/recuperacao/RecuperarSenha";
import Dashboard from "./features/chamados/components/Dashboard";
import ChamadosPage from "./features/chamados/gestao/ChamadosPage";
import ChamadoDetalhePage from "./features/chamados/gestao/ChamadoDetalhePage";
import NovoChamadoPage from "./features/chamados/gestao/NovoChamadoPage";
import DescritivosPage from "./features/descritivos/DescritivosPage";
import AgendaPage from "./features/agenda/AgendaPage";
import EntradaEquipe from "./features/equipe/EntradaEquipe";
import EscolherContrato from "./features/equipe/EscolherContrato";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: (failureCount, error: any) => {
        // Não fazer retry em caso de 401 (não autorizado)
        if (error?.response?.status === 401) {
          return false;
        }
        // Retry apenas 1 vez para outros erros
        return failureCount < 1;
      },
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<RecuperarSenha />} />
          <Route path="/equipe" element={<EntradaEquipe />} />
          <Route
            path="/equipe/contratos"
            element={
              <PrivateRoute>
                <Layout>
                  <EscolherContrato />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/chamado/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/chamados"
            element={
              <PrivateRoute>
                <Layout>
                  <ChamadosPage />
                </Layout>
              </PrivateRoute>
            }
          />
          {/* Antes da rota com :id — "novo" é segmento fixo, não identificador. */}
          <Route
            path="/chamados/novo"
            element={
              <PrivateRoute>
                <Layout>
                  <NovoChamadoPage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/chamados/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <ChamadoDetalhePage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/descritivos"
            element={
              <PrivateRoute>
                <Layout>
                  <DescritivosPage />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/agenda"
            element={
              <PrivateRoute>
                <Layout>
                  <AgendaPage />
                </Layout>
              </PrivateRoute>
            }
          />
          {/* Entradas canônicas do quadro, como a seção 7.1 da spec propõe.
              "/" e "/chamado/:id" continuam valendo para os links já enviados. */}
          <Route
            path="/kanban"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/kanban/:id"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
        </Routes>

        {/* Componente de informação do ambiente (só aparece em dev) */}
        <EnvironmentInfo />

        {/* Debug de autenticação (só em dev) */}
        <AuthDebugger />
      </Router>
    </QueryClientProvider>
  );
}

export default App;
